// Player da composição Reels — a MESMA do render-worker, então o preview é o MP4.
// Único arquivo do editor que importa Remotion.
import { useEffect, useMemo, useRef } from 'react';
import { Player, type PlayerRef } from '@remotion/player';
import { Reels, REELS_DEFAULT_PROPS, reelsMetadata } from '../../../video-compositions';
import type { ReelsProps } from '../../../types/videoEdit';
import type { MediaController } from './playhead';

export function ReelsPreview({ props, onController, loop = false, autoPlay = false, controls = false, maxSeconds, className = '' }: {
  props: ReelsProps;
  onController?: (c: MediaController | null) => void;
  loop?: boolean;
  autoPlay?: boolean;
  controls?: boolean;
  /** limita a duração (demo da aba Estilo toca só o começo) */
  maxSeconds?: number;
  className?: string;
}) {
  const ref = useRef<PlayerRef>(null);
  const inputProps = useMemo(() => ({ ...REELS_DEFAULT_PROPS, ...props, assetBase: props.assetBase || REELS_DEFAULT_PROPS.assetBase }) as ReelsProps, [props]);
  const meta = reelsMetadata(inputProps as any);
  const frames = maxSeconds ? Math.min(meta.durationInFrames, Math.max(1, Math.round(maxSeconds * meta.fps))) : meta.durationInFrames;
  const fps = meta.fps;

  useEffect(() => {
    if (!onController) return;
    const c: MediaController = {
      getTime: () => (ref.current?.getCurrentFrame() ?? 0) / fps,
      seek: t => ref.current?.seekTo(Math.max(0, Math.min(frames - 1, Math.round(t * fps)))),
      play: () => ref.current?.play(),
      pause: () => ref.current?.pause(),
      isPaused: () => !ref.current?.isPlaying(),
      setMuted: m => { if (m) ref.current?.mute(); else ref.current?.unmute(); },
      isMuted: () => !!ref.current?.isMuted(),
    };
    onController(c);
    return () => onController(null);
  }, [onController, fps, frames]);

  useEffect(() => {
    // autoplay só passa no navegador sem som
    if (autoPlay) { ref.current?.mute(); ref.current?.play(); }
  }, [autoPlay]);

  return (
    <Player
      ref={ref}
      component={Reels as any}
      inputProps={inputProps as any}
      durationInFrames={frames}
      compositionWidth={meta.width}
      compositionHeight={meta.height}
      fps={fps}
      loop={loop}
      controls={controls}
      clickToPlay
      acknowledgeRemotionLicense
      className={className}
      style={{ width: '100%', height: '100%' }}
    />
  );
}
